import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening`;

    static getInstance() {
        if (!ComplianceScreeningService.instance) {
            ComplianceScreeningService.instance = new ComplianceScreeningService();
        }

        return ComplianceScreeningService.instance;
    }

    async startScreeningPerson(params = {}) {
        const response = await axios.get(
            `${this.resource}/management-team/search-persons`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async startScreeningBusiness(params = {}) {
        const response = await axios.get(
            `${this.resource}/business/search`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchComplianceScreeningResult(supplierId, params = {}) {
        const response = await axios.get(
            `${this.resource}/supplier/${supplierId}/data`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchPersonScreeningResultItemDetails(personId, params = {}) {
        // return new Promise((res) => {
        //     setTimeout(() => {
        //         res({
        //             "version": 15346444345,
        //             "firstName": "John",
        //             "middleName": "Christofer",
        //             "lastName": "Doe",
        //             "gender": "Male",
        //             "isDeleted": false,
        //             "deletionReason": {
        //                 "reason": "Duplicate profile",
        //                 "otherReason": "Should not have been there in the first place."
        //             },
        //             "isDeceased": false,
        //             "aliases": [
        //                 {
        //                     "firstName": "Doe",
        //                     "middleName": "string",
        //                     "lastName": "John",
        //                     "type": "Name Spelling Variation"
        //                 }
        //             ],
        //             "datesOfBirthISO": [
        //                 "1959-06-13",
        //                 "1960"
        //             ],
        //             "datesOfDeathISO": [
        //                 "1959"
        //             ],
        //             "nationalitiesISOCodes": [
        //                 "US",
        //                 "NL"
        //             ],
        //             "addresses": [
        //                 {
        //                     "addressType": "Place of birth",
        //                     "line1": "1 Main Street",
        //                     "line2": "Weesperplein",
        //                     "postcode": "12221",
        //                     "city": "Amsterdam",
        //                     "county": "Netherlands",
        //                     "countyAbbreviation": "NL",
        //                     "countryISOCode": "NL"
        //                 }
        //             ],
        //             "profileImages": [
        //                 "string"
        //             ],
        //             "notes": [
        //                 {
        //                     "value": "A sample note"
        //                 }
        //             ],
        //             "contactEntries": [
        //                 {
        //                     "category": "Email",
        //                     "value": "testemail@example.com"
        //                 }
        //             ],
        //             "identifiers": [
        //                 {
        //                     "category": "NPI Number",
        //                     "value": "46333"
        //                 }
        //             ],
        //             "findings": [
        //                 {
        //                     "datasets": [
        //                         "PEP-FORMER",
        //                         "INS"
        //                     ],
        //                     "evidence_id": "string",
        //                     "original_url": "https://www.example.com",
        //                     "is_copyrighted": true,
        //                     "title": "Example Arrested for Money Laundering",
        //                     "credibility": "Medium",
        //                     "language": "eng",
        //                     "summary": "string",
        //                     "keywords": "Money Laundering, AML",
        //                     "capture_date_iso": "2020-01-12",
        //                     "publication_date_iso": "2020-01-11",
        //                     "assetURL": "string"
        //                 }
        //             ],
        //             "sanEntries": {
        //                 "current": [
        //                     {
        //                         "sanctionID": "124122",
        //                         "measures": [
        //                             "Travel Ban"
        //                         ],
        //                         "regime": {
        //                             "body": "United Nations Security Council (UNSC)",
        //                             "name": "Iranian Sanctions List",
        //                             "origin": "United Nations",
        //                             "types": [
        //                                 "Non-Proliferation",
        //                                 "Human Rights"
        //                             ]
        //                         },
        //                         "events": [
        //                             {
        //                                 "type": "Added",
        //                                 "dateISO": "2021-05-05",
        //                                 "evidenceIDs": [
        //                                     "12422"
        //                                 ]
        //                             }
        //                         ]
        //                     }
        //                 ],
        //                 "former": [
        //                     {
        //                         "sanctionID": "124122",
        //                         "measures": [
        //                             "Travel Ban"
        //                         ],
        //                         "regime": {
        //                             "body": "United Nations Security Council (UNSC)",
        //                             "name": "Iranian Sanctions List",
        //                             "origin": "United Nations",
        //                             "types": [
        //                                 "Non-Proliferation",
        //                                 "Human Rights"
        //                             ]
        //                         },
        //                         "events": [
        //                             {
        //                                 "type": "Added",
        //                                 "dateISO": "2021-05-05",
        //                                 "evidenceIDs": [
        //                                     "12422"
        //                                 ]
        //                             }
        //                         ]
        //                     }
        //                 ]
        //             },
        //             "relEntries": [
        //                 {
        //                     "category": "Law Enforcement",
        //                     "subcategory": "Police - Avon and Somerset Police - Wanted & In Court - United Kingdom",
        //                     "events": [
        //                         {
        //                             "type": "Arrest",
        //                             "currencyCode": "USD",
        //                             "amount": 1000,
        //                             "period": {
        //                                 "days": 0,
        //                                 "years": 0,
        //                                 "months": 0
        //                             },
        //                             "dateISO": "2021-04-09",
        //                             "evidenceIDs": [
        //                                 "354363"
        //                             ]
        //                         }
        //                     ]
        //                 }
        //             ],
        //             "rreEntries": [
        //                 {
        //                     "category": "Law Enforcement",
        //                     "subcategory": "Identity Theft",
        //                     "events": [
        //                         {
        //                             "type": "Court Proceedings in Progress: Remand",
        //                             "dateISO": "2021-04-09",
        //                             "evidenceIDs": [
        //                                 "354363"
        //                             ]
        //                         }
        //                     ]
        //                 }
        //             ],
        //             "poiEntries": [
        //                 {
        //                     "category": "Local Government Administration",
        //                     "evidenceIDs": [
        //                         "542622"
        //                     ],
        //                     "positions": [
        //                         {
        //                             "position": "The name of the political position.",
        //                             "segment": "Segment",
        //                             "countryISOCode": "ES",
        //                             "dateFromISO": "2021-03-12",
        //                             "dateToISO": "2021-03-12"
        //                         }
        //                     ]
        //                 }
        //             ],
        //             "insEntries": [
        //                 {
        //                     "type": "Individual Voluntary Arrangement",
        //                     "insolvencyIDNumber": "string",
        //                     "solicitor": "HM Revenue and Customs,, Solicitor's Office & Legal Services, South West Wing, Bush House, Strand, London, WC2B 4RD",
        //                     "court": "Voluntary Liquidation Cases",
        //                     "petitioner": "Commissioners For Hm Revenue And Customs",
        //                     "debt": "GBP 5,748",
        //                     "accountantInBankruptcyCaseNumber": "2020/601289",
        //                     "insolvencyStartDateISO": "2020-10-05",
        //                     "insolvencyEndDateISO": "2024-10-05",
        //                     "hearingDateISO": "2020-10-01",
        //                     "presentedDateOfPetitionISO": "2020-10-01",
        //                     "gazetteIssueDateISO": "2020-10-05",
        //                     "awardDateISO": "2020-10-03",
        //                     "firstOrderDateISO": "2020-10-11",
        //                     "evidenceIDs": [
        //                         "252231"
        //                     ]
        //                 }
        //             ],
        //             "ddEntries": [
        //                 {
        //                     "caseReference": "INV5943477",
        //                     "reason": "Disqualification order or undertaking; and reporting provisions.",
        //                     "conduct": "Brufix Glazing System Installations Limited",
        //                     "dateFromISO": "2021-03-09",
        //                     "dateToISO": "2027-03-08",
        //                     "evidenceIDs": [
        //                         "string"
        //                     ]
        //                 }
        //             ],
        //             "pepEntries": {
        //                 "pepTier": "PEP Tier 2",
        //                 "current": [
        //                     {
        //                         "countryISOCode": "GB",
        //                         "segment": "Executive Branch - Head and Members of Government and Deputies",
        //                         "position": "Prime Minister (Kryeministër) | Council of Ministers (Këshillii Ministrave)",
        //                         "dateFromISO": "2019",
        //                         "dateToISO": "2022-01-01",
        //                         "evidenceIDs": [
        //                             "362233"
        //                         ]
        //                     }
        //                 ],
        //                 "former": [
        //                     {
        //                         "countryISOCode": "GB",
        //                         "segment": "Executive Branch - Head and Members of Government and Deputies",
        //                         "position": "Prime Minister (Kryeministër) | Council of Ministers (Këshillii Ministrave)",
        //                         "dateFromISO": "2019",
        //                         "dateToISO": "2022-01-01",
        //                         "evidenceIDs": [
        //                             "362233"
        //                         ]
        //                     }
        //                 ]
        //             },
        //             "pepByAssociationEntries": [
        //                 {
        //                     "id": "string",
        //                     "evidenceIDs": [
        //                         "string"
        //                     ]
        //                 }
        //             ],
        //             "individualLinks": [
        //                 {
        //                     "firstName": "Jane",
        //                     "middleName": "Christopher",
        //                     "lastName": "Doe",
        //                     "relationship": "John Doe is the brother of Jane Doe.",
        //                     "ownershipPercentage": 75,
        //                     "id": "string",
        //                     "monitoringID": "NQZGH3oUYAtYFw",
        //                     "datasets": [
        //                         "DD",
        //                         "INS",
        //                         "PEP-CURRENT",
        //                         "PEP-FORMER",
        //                         "PEP-LINKED",
        //                         "POI",
        //                         "REL",
        //                         "RRE",
        //                         "SAN-CURRENT",
        //                         "SAN-FORMER",
        //                         "GRI"
        //                     ]
        //                 }
        //             ],
        //             "businessLinks": [
        //                 {
        //                     "name": "John Doe Limited",
        //                     "id": "string",
        //                     "monitoringID": "NQZGH3oUYAtYFw",
        //                     "relationship": "John Doe is a board member of Haribo Limited",
        //                     "ownershipPercentage": 75,
        //                     "datasets": [
        //                         "INS",
        //                         "PEP-LINKED",
        //                         "POI",
        //                         "REL",
        //                         "RRE",
        //                         "SAN-CURRENT",
        //                         "SAN-FORMER",
        //                         "SOE-CURRENT",
        //                         "GRI"
        //                     ],
        //                     "individualLinks": [
        //                         {
        //                             "firstName": "Jane",
        //                             "middleName": "Christopher",
        //                             "lastName": "Doe",
        //                             "relationship": "John Doe is the brother of Jane Doe.",
        //                             "ownershipPercentage": 75,
        //                             "id": "string",
        //                             "monitoringID": "NQZGH3oUYAtYFw",
        //                             "datasets": [
        //                                 "DD",
        //                                 "INS",
        //                                 "PEP-CURRENT",
        //                                 "PEP-FORMER",
        //                                 "PEP-LINKED",
        //                                 "POI",
        //                                 "REL",
        //                                 "RRE",
        //                                 "SAN-CURRENT",
        //                                 "SAN-FORMER",
        //                                 "GRI"
        //                             ]
        //                         }
        //                     ]
        //                 }
        //             ],
        //             "griEntries": [
        //                 {
        //                     "evidenceID": "235343",
        //                     "title": "EDD Report - Executive Summary Report",
        //                     "summary": "The source provides in-depth information about the subject based on an Enhanced Due Diligence investigation into the subject's source of wealth, potential political exposure and reputational risk exposure.",
        //                     "keywords": "Source of Wealth"
        //                 }
        //             ],
        //             "datasets": [
        //                 "DD",
        //                 "INS",
        //                 "PEP-CURRENT",
        //                 "PEP-FORMER",
        //                 "PEP-LINKED",
        //                 "POI",
        //                 "REL",
        //                 "RRE",
        //                 "SAN-CURRENT",
        //                 "SAN-FORMER",
        //                 "GRI"
        //             ],
        //             "monitoringID": "NQZGH3oUYAtYFw"
        //         });
        //     }, 500);
        // })

        const response = await axios.get(
            `${this.resource}/management-team/${personId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchBusinessScreeningResultItemDetails(supplierId, params = {}) {
        const response = await axios.get(
            `${this.resource}/businesses/${supplierId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async updateResultFalsePositive(payload) {
        const response = await axios.post(
            `${this.resource}/results/mark_false_positive`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}
